<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: GCI 2020
      Author: Dtsmart
    Author URL: http://dtsmart.vn
========================================================================================== -->


<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="flex no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto" />
            </div>
            <div id="login-left" class="sm:w-full md:w-full lg:w-1/2 position-relative">
              <transition name="list">
                <div
                  v-show="type=='login'"
                  class="login-card vx-col w-full d-theme-dark-bg"
                  v-on:keyup.enter="login"
                >
                  <div class="p-8 login-tabs-container" style="padding-top: 30px !important">
                    <div class="vx-card__title mb-2">
                      <h4 class="mb-4">Login</h4>
                      <p class="font-italic">
                        If you're using IE or FireFox Browser, please use
                        <a
                          class="cursor-pointer"
                          target="_blank"
                          href="https://www.google.com/intl/vi_vn/chrome/"
                        >GG Chrome Browser</a> to have better experience
                      </p>
                      <p class="pt-6">Welcome back, please login to your account.</p>
                    </div>
                    <div
                      v-if="wrong_info"
                      class="text-danger text-sm mb-4"
                    >Incorrect ID, username or password</div>
                    <div>
                      <!-- <vs-input required v-validate="'required'" :danger="errors.has('username')" name="id" v-model="id" danger-text="ID is required" class="id-input w-full mb-4"/> -->
                      <vs-input
                        required
                        v-validate="'required'"
                        name="id"
                        icon-no-border
                        icon="icon icon-globe"
                        icon-pack="feather"
                        v-model="id"
                        class="w-full mb-6"
                        :danger="errors.has('id')"
                        danger-text="ID is required"
                        @input="wrong_info = false"
                        placeholder="ID"
                      />
                      <vs-input
                        required
                        v-validate="'required'"
                        name="username"
                        icon-no-border
                        icon="icon icon-user"
                        icon-pack="feather"
                        v-model="username"
                        class="w-full"
                        :danger="errors.has('username')"
                        danger-text="Username is required"
                        @input="wrong_info = false"
                        placeholder="Username"
                      />
                      <div class="mb-base" style="position: relative; height: 40px !important">
                        <vs-input
                          required
                          v-validate="'required'"
                          type="password"
                          name="password"
                          icon-no-border
                          icon="icon icon-lock"
                          icon-pack="feather"
                          v-model="password"
                          class="w-full mt-6"
                          :danger="errors.has('password')"
                          danger-text="Password is required"
                          @input="wrong_info = false"
                          id="myInput"
                          style="position:absolute; top: 0; left: 0"
                          placeholder="Password"
                        />
                        <div
                          v-if="password != ''"
                          style="position: absolute; top: 32px; right: 10px;"
                        >
                          <div v-if="show == false">
                            <eye-icon
                              size="1.25x"
                              class="custom-class text-grey-custom"
                              @click="showPassword"
                            ></eye-icon>
                          </div>
                          <div v-else>
                            <eye-off-icon
                              size="1.25x"
                              class="custom-class text-grey-custom"
                              @click="showPassword"
                            ></eye-off-icon>
                          </div>
                        </div>
                      </div>
                      <div class="flex flex-wrap justify-between my-5 pt-4 align-center">
                        <div>
                          <vs-button
                            class="float-right gradient gradient-primary no-shadow"
                            @click="login"
                          >Login</vs-button>
                        </div>
                        <div @click="forgot">
                          <router-link to>Forgot Password?</router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
              <transition name="list">
                <div
                  v-show="type=='email'"
                  class="login-card vx-col w-full d-theme-dark-bg h-full my-auto"
                >
                  <div class="p-8 login-tabs-container" style="padding-top: 70px !important">
                    <div class="vx-card__title mb-4">
                      <h4 class="mb-4">Send Email</h4>
                      <p class="font-italic">
                        If you're using IE or FireFox Browser, please use
                        <a
                          class="cursor-pointer"
                          target="_blank"
                          href="https://www.google.com/intl/vi_vn/chrome/"
                        >GG Chrome Browser</a> to have better experience
                      </p>
                      <p class="pt-6">Welcome back, please give us your email to receive the OTP.</p>
                      <div class="mt-4">
                        <vs-input
                          required
                          v-validate="'required'"
                          name="id"
                          icon-no-border
                          icon="icon icon-globe"
                          icon-pack="feather"
                          v-model="id"
                          class="w-full mb-6"
                          :danger="errors.has('id')"
                          danger-text="ID is required"
                          @input="wrong_info = false"
                          placeholder="ID"
                        />
                        <vs-input
                          required
                          v-validate="'required'"
                          name="email"
                          icon-no-border
                          icon="icon icon-mail"
                          icon-pack="feather"
                          label-placeholder="Email"
                          v-model="email"
                          class="w-full mt-6"
                          :danger="errors.has('email')"
                          danger-text="Email is required"
                        />
                      </div>
                    </div>
                    <div class="flex flex-wrap justify-between align-center mt-6">
                      <div>
                        <vs-button
                          color="primary"
                          type="filled"
                          class="w-full rounded-item text-sm gradient gradient-primary no-shadow"
                          @click="backToLogin"
                        >Back To Login</vs-button>
                      </div>
                      <div>
                        <vs-button
                          color="primary"
                          type="filled"
                          class="w-full rounded-item text-sm gradient gradient-primary no-shadow"
                          disabled
                          v-if="!StringHelper.validateEmail(email)"
                        >SEND</vs-button>
                        <vs-button
                          color="primary"
                          type="filled"
                          class="w-full rounded-item text-sm gradient gradient-primary no-shadow"
                          v-else
                          @click="sendEmail"
                        >SEND</vs-button>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
              <transition name="list">
                <div v-show="type=='otp'" class="login-card vx-col w-full d-theme-dark-bg">
                  <div class="p-8 login-tabs-container" style="padding-top: 70px !important">
                    <div class="vx-card__title mb-4">
                      <h4 class="mb-4">Send OTP</h4>
                      <p class="font-italic">
                        If you're using IE or FireFox Browser, please use
                        <a
                          class="cursor-pointer"
                          target="_blank"
                          href="https://www.google.com/intl/vi_vn/chrome/"
                        >GG Chrome Browser</a> to have better experience
                      </p>
                      <p
                        class="pt-6"
                      >Welcome back, please check your email and give us the OTP to change password.</p>
                      <div class="mt-4">
                        <vs-input
                          required
                          :maxlength="6"
                          v-validate="'required'"
                          name="otp"
                          icon-no-border
                          icon="icon icon-shield"
                          icon-pack="feather"
                          label-placeholder="OTP"
                          v-model="otp"
                          class="w-full mt-6"
                          :danger="errors.has('otp')"
                          danger-text="OTP is required"
                          v-on:keypress="isNumber($event)"
                        />
                      </div>
                    </div>
                    <div class="flex flex-wrap justify-between align-center mt-6">
                      <div>
                        <vs-button
                          color="primary"
                          type="filled"
                          class="w-full rounded-item text-sm gradient gradient-primary no-shadow"
                          @click="backToLogin"
                        >Go Back To Login</vs-button>
                      </div>
                      <div>
                        <vs-button
                          color="primary"
                          type="filled"
                          class="w-full rounded-item text-sm gradient gradient-primary no-shadow"
                          disabled
                          v-if="otp.length != 6"
                        >SEND OTP</vs-button>
                        <vs-button
                          color="primary"
                          type="filled"
                          class="w-full rounded-item text-sm gradient gradient-primary no-shadow"
                          @click="sendOTP"
                          v-else
                        >SEND OTP</vs-button>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
              <transition name="list">
                <div
                  v-show="type=='new-pass'"
                  class="login-card vx-col w-full d-theme-dark-bg"
                  v-on:keyup.enter="backLogin"
                  :key="key_otp"
                >
                  <div class="p-8 login-tabs-container" style="padding-top: 45px !important">
                    <div class="vx-card__title mb-4">
                      <h4 class="mb-4">Change Password</h4>
                      <p class="font-italic">
                        If you're using IE or FireFox Browser, please use
                        <a
                          class="cursor-pointer"
                          target="_blank"
                          href="https://www.google.com/intl/vi_vn/chrome/"
                        >GG Chrome Browser</a> to have better experience
                      </p>
                      <p class="pt-6">Welcome back, please create a new password to reset password.</p>
                    </div>
                    <div>
                      <div style="position: relative; height: 40px !important">
                        <vs-input
                          required
                          v-validate="'required'"
                          type="password"
                          name="new_pass"
                          icon-no-border
                          icon="icon icon-lock"
                          label-placeholder="New Password"
                          icon-pack="feather"
                          v-model="new_pass"
                          class="w-full mt-6"
                          :danger="errors.has('new_pass')"
                          id="newPass"
                          danger-text="New password is required"
                        />
                        <div
                          v-if="new_pass != ''"
                          style="position: absolute; right: 10px; top: 10px"
                        >
                          <div v-if="showNew == false">
                            <eye-icon
                              size="1.25x"
                              class="custom-class text-grey-custom"
                              @click="showNewPassword"
                            ></eye-icon>
                          </div>
                          <div v-else>
                            <eye-off-icon
                              size="1.25x"
                              class="custom-class text-grey-custom"
                              @click="showNewPassword"
                            ></eye-off-icon>
                          </div>
                        </div>
                      </div>
                      <div class="mb-base" style="position: relative; height: 40px !important">
                        <vs-input
                          required
                          v-validate="'required'"
                          type="password"
                          name="confirm_pass"
                          icon-no-border
                          icon="icon icon-lock"
                          label-placeholder="Confirm Password"
                          icon-pack="feather"
                          v-model="confirm_pass"
                          class="w-full mt-6"
                          :danger="errors.has('confirm_pass')"
                          danger-text="Confirm password is required"
                          id="confirmPass"
                          style="position:absolute; top: 0; left: 0"
                        />
                        <div
                          v-if="confirm_pass != ''"
                          style="position: absolute; top: 32px; right: 10px;"
                        >
                          <div v-if="showConfirm == false">
                            <eye-icon
                              size="1.25x"
                              class="custom-class text-grey-custom"
                              @click="showConfirmPassword"
                            ></eye-icon>
                          </div>
                          <div v-else>
                            <eye-off-icon
                              size="1.25x"
                              class="custom-class text-grey-custom"
                              @click="showConfirmPassword"
                            ></eye-off-icon>
                          </div>
                        </div>
                      </div>
                      <div class="flex flex-wrap justify-between my-5 pt-4 align-center mt-6">
                        <div>
                          <vs-button
                            color="primary"
                            type="filled"
                            class="w-full rounded-item text-sm gradient gradient-primary no-shadow"
                            @click="backToLogin"
                          >Go Back To Login</vs-button>
                        </div>
                        <div>
                          <vs-button
                            color="primary"
                            type="filled"
                            class="w-full rounded-item text-sm gradient gradient-primary no-shadow"
                            disabled
                            v-if="new_pass !== confirm_pass || new_pass == '' && confirm_pass == ''"
                          >Change Password</vs-button>
                          <vs-button
                            color="primary"
                            type="filled"
                            class="w-full rounded-item text-sm gradient gradient-primary no-shadow"
                            @click="backLogin"
                            v-else
                          >Change Password</vs-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { StringHelper } from "../../models/string_helper";
import { ChromeIcon } from "vue-feather-icons";
import { EyeIcon } from "vue-feather-icons";
import { EyeOffIcon } from "vue-feather-icons";

export default {
  components: {
    ChromeIcon,
    StringHelper,
    EyeIcon,
    EyeOffIcon
  },
  data() {
    return {
      StringHelper,
      // errorsa: [],
      id: "",
      username: "",
      password: "",
      checkbox_remember_me: false,
      wrong_info: false,
      show: false,
      showNew: false,
      showConfirm: false,
      email: "",
      otp: "",
      new_pass: "",
      confirm_pass: "",
      type: "login",
      key_otp: 0,
      isOpenLoading: false
    };
  },
  created() {
    localStorage.removeItem("fromToken");
    let id = localStorage.getItem("domainId");
    let token = localStorage.getItem("accessToken");
    if (id != null && id != "" && token != null && token != "") {
      this.$store
        .dispatch("auth/GET_DOMAIN", id)
        .then(() => {
          this.$store
            .dispatch("auth/loginByToken", token)
            .then(() => {
              location.reload();
              this.closeLoading();
              // this.$router.push(this.$route.query.redirect || '/checkout');
            })
            .catch(e => {
              console.log(e);
              this.closeLoading();
            });
        })
        .catch(error => {
          console.log(error);
          this.closeLoading();
        });
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.auth.userInfo;
    },
    checkinData() {
      return this.$store.state.checkin.checkinData;
    },
    checkOtp() {
      return this.$store.state.auth.checkOtp;
    }
  },
  methods: {
    backToLogin() {
      this.type = "login";
      this.email = "";
      this.otp = "";
      this.new_pass = "";
      this.confirm_pass = "";
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        (charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode !== 46) ||
        (charCode == 46 && this.otp.indexOf(".") != -1)
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    forgot() {
      this.type = "email";
    },
    sendEmail() {
      if(this.email != '' && this.id !=''){
        const obj = {
          email: this.email
        };
        if (!this.isOpenLoading) {
          this.openLoadingInDiv();
        }
        this.$store.dispatch("auth/GET_DOMAIN", this.id).then(() => {
          this.$store.dispatch("auth/FORGOT_PASSWORD", obj).then(() => {
              this.closeLoading();
              this.type = "otp";
              this.$vs.notify({
                title: "Success",
                text: "Please check your Inbox or Spam for the email.",
                color: "success",
                position: "top-right"
              });
            })
            .catch(() => {
              this.closeLoading();
              this.type = "email";
              this.$vs.notify({
                title: "Fail",
                text: "There is no user with such email.",
                color: "danger",
                position: "top-right"
              });
            });
        }).catch(() => {
          this.closeLoading();
        });
      }
    },
    sendOTP() {
      const obj = {
        otp: this.otp
      };
      this.$store
        .dispatch("auth/CHECK_OTP", obj)
        .then(() => {
          this.type = "new-pass";
          this.key_otp++;
          this.$vs.notify({
            title: "Success",
            text: "Check OTP Success",
            color: "success",
            position: "top-right"
          });
        })
        .catch(() => {
          this.type = "otp";
          this.$vs.notify({
            title: "Fail",
            text: "Incorrect OTP",
            color: "danger",
            position: "top-right"
          });
        });
    },
    backLogin() {
      const data = {
        request_id: this.checkOtp.request_id,
        new_password: this.new_pass,
        confirm_password: this.confirm_pass
      };
      this.$store
        .dispatch("auth/RESET_PASSWORD", data)
        .then(() => {
          this.type = "login";
          this.$vs.notify({
            title: "Success",
            text: "Reset Password Success",
            color: "success",
            position: "top-right"
          });
        })
        .catch(() => {
          this.type = "new-pass";
          this.$vs.notify({
            title: "Fail",
            text: "Somnething went wrong",
            color: "danger",
            position: "top-right"
          });
        });
    },
    openLoadingInDiv() {
      this.$vs.loading({
        container: "#app",
        scale: 0.8
      });
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout(() => {
        if (this.isOpenLoading) {
          this.closeLoading();
          // this.$vs.notify({
          //   title: "Notification",
          //   text: "Login failed",
          //   color: "danger",
          //   position: "top-right"
          // });
          this.$vs.dialog({
            color: "danger",
            title: "Notification",
            text: "Login failed",
            acceptText: "OK"
          });
        }
      }, 10000);
    },
    closeLoading() {
      this.$vs.loading.close("#app > .con-vs-loading");
      this.isOpenLoading = false;
    },
    showPassword() {
      var x = document.getElementById("myInput");
      if (x.type === "password") {
        this.show = true;
        x.type = "text";
      } else {
        this.show = false;
        x.type = "password";
      }
    },
    showNewPassword() {
      var x = document.getElementById("newPass");
      if (x.type === "password") {
        this.showNew = true;
        x.type = "text";
      } else {
        this.showNew = false;
        x.type = "password";
      }
    },
    showConfirmPassword() {
      var x = document.getElementById("confirmPass");
      if (x.type === "password") {
        this.showConfirm = true;
        x.type = "text";
      } else {
        this.showConfirm = false;
        x.type = "password";
      }
    },
    login: function() {
      if (this.username != "" && this.password != "" && this.id != "") {
        const obj = {
          username: this.username,
          password: this.password
        };
        if (!this.isOpenLoading) {
          this.openLoadingInDiv();
        }
        if (this.id != "") {
          this.$store
            .dispatch("auth/GET_DOMAIN", this.id)
            .then(() => {
              this.$store
                .dispatch("auth/login", obj)
                .then(() => {
                  //this.closeLoading();
                  //this.$router.push('/checkout');
                  location.reload();
                  this.closeLoading();
                  // this.$router.push(this.$route.query.redirect || '/checkout');
                })
                .catch(() => {
                  if (this.username != "" && this.password != "") {
                    this.wrong_info = true;
                  }
                  this.closeLoading();
                });
            })
            .catch(error => {
              console.log(error);
              this.wrong_info = true;
              this.closeLoading();
            });
        }
      }
      this.$validator.validateAll();
    }
  }
};
</script>

<style lang="scss">
#page-login {
  .list-enter {
    opacity: 0.4;
    float: right;
    transform: translateX(-100%);
  }

  .list-leave-to {
    opacity: 0.1;
    // float: right;
    // transform: translateX(100%);
    // z-index: -1;
  }

  .list-enter-active,
  .list-leave-active {
    transition: all 0.5s;
  }
  .login-card {
    // min-height: 466.67px;
    min-height: 488px;
  }
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
  .vs-input--input.hasIcon {
    padding: 0.55rem 1rem 0.55rem 2.2rem;
  }
  .vs-input--placeholder {
    top: 3px;
  }
  .input-icon-validate {
    display: none;
  }

  // .id-input {
  //   .vs-input--input.normal {
  //     padding: 0.55rem 0.55rem 0.55rem 2rem;
  //   }
  //   position: relative;
  //   &::after {
  //     content: 'ID';
  //     position: absolute;
  //     top: 9px;
  //     left: 10px;
  //     width: 30px;
  //     height: 100%;
  //     color: rgba(#000, 0.4);
  //   }
  // }
}
</style>
